
export default {
 name: "Whybox",
 props: {
    id: {
        default: '',
        type: String,
    },
    last: {
        default: '',
        type: String
    },
    icon: {
        default: '',
        type: String
    },
    alt: {
        default: '',
        type: String
    }
 },
 data() {
    return {

    }
  },
  render() {
    const slot = this.$slots.default
    //  return slot.text.replace(/,/g, "")
    return slot
  },
}
